import { render } from "./Legals.vue?vue&type=template&id=9e3149a8&scoped=true"
import script from "./Legals.vue?vue&type=script&lang=js"
export * from "./Legals.vue?vue&type=script&lang=js"

import "./Legals.vue?vue&type=style&index=0&id=9e3149a8&lang=scss&scoped=true"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3149a8"]])

export default __exports__